import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { AuthHttpConfig } from "./auth-http-config";

export const tokenInterceptor: HttpInterceptorFn = (request, next) => {
  const authorizationToken = inject(AuthHttpConfig).getPrefixedToken();

  if (authorizationToken) {
    request = request.clone({
      setHeaders: {
        Authorization: authorizationToken,
      },
    });
  }

  return next(request);
};
